import React from 'react';
import { Dialog } from '@mui/material';
import { DialogContent } from '~/components/organisms/DialogContent/index.ts';
import { Typography } from '~/index.ts';

export interface UnsavedDialogProps {
  onSave: () => void;
  onCancel: () => void;
  onExit: () => void;
}

const UnsavedDialog: React.FC<UnsavedDialogProps> = ({
  onExit,
  onSave,
  onCancel,
}) => {
  const bodyContent = (
    <Typography variant="h6">
      Do you want to save the changes you have made to this deal?
    </Typography>
  );
  const title = 'Unsaved changes';
  const secondaryButton = { children: 'Exit without saving', onClick: onExit };

  const primaryButton = { children: 'Save changes & exit', onClick: onSave };

  return (
    <Dialog open onClose={onCancel}>
      <DialogContent
        title={title}
        bodyContent={bodyContent}
        secondaryButton={secondaryButton}
        primaryButton={primaryButton}
        onCancel={onCancel}
        size="medium"
      />
    </Dialog>
  );
};

export default UnsavedDialog;
